import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

export type OndernemingFormGroup = FormGroup<{
    naam: FormControl<string | null>;
    werkzaamheden: FormControl<string | null>;
    ondernemingsvorm: FormControl<string | null>;
    administrationId: FormControl<number | null>;
}>;

export function createOndernemingFormGroup(formBuilder: FormBuilder): OndernemingFormGroup {
    return formBuilder.group({
        naam: new FormControl<string | null>(null),
        werkzaamheden: new FormControl<string | null>(null),
        ondernemingsvorm: new FormControl<string | null>(null),
        administrationId: new FormControl<number | null>(null),
    });
}
